import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { t as theme } from '../theme/themes/default-BrkF3upi.js';
import { g as getPadding } from '../LocalModules/storm-ui-utils/dist/esm/getPadding-Bvzhcf_u-BhHYy5ob.js';
import { D as DEVICE_TYPES } from '../LocalModules/storm-ui-utils/dist/esm/deviceTypes-wW4MAd2m-wW4MAd2m.js';

const getBgColor = color => {
  if (theme && theme.pageLayout && typeof theme.pageLayout.section.background[color] !== 'undefined') {
    return theme.pageLayout.section.background[color];
  }
  return 'none';
};
const BoxStyled = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30063520__sc-qh4od4-0"
})(["border-radius:", ";", " box-sizing:border-box;padding-block-start:", "px;padding-block-end:", "px;padding-inline-start:", "px;padding-inline-end:", "px;", " ", " ", " ", " ", " ", ""], ({
  theme
}) => theme.card.radius, ({
  $bgColor
}) => $bgColor && css(["background:", ";"], getBgColor($bgColor)), ({
  theme,
  $paddingBlockStart
}) => getPadding(theme, $paddingBlockStart), ({
  theme,
  $paddingBlockEnd
}) => getPadding(theme, $paddingBlockEnd), ({
  theme,
  $paddingInlineStart
}) => getPadding(theme, $paddingInlineStart), ({
  theme,
  $paddingInlineEnd
}) => getPadding(theme, $paddingInlineEnd), ({
  $flex
}) => css(["flex:", ";"], $flex), ({
  $basis
}) => css(["flex-basis:", ";"], $basis), ({
  $grow
}) => css(["flex-grow:", ";"], $grow), ({
  $shrink
}) => css(["flex-shrink:", ";"], $shrink), ({
  $order
}) => css(["order:", ";"], $order), isMobile(css(["padding-block-start:", "px;padding-block-end:", "px;padding-inline-start:", "px;padding-inline-end:", "px;"], ({
  theme,
  $paddingBlockStart
}) => getPadding(theme, $paddingBlockStart, DEVICE_TYPES.MOBILE), ({
  theme,
  $paddingBlockEnd
}) => getPadding(theme, $paddingBlockEnd, DEVICE_TYPES.MOBILE), ({
  theme,
  $paddingInlineStart
}) => getPadding(theme, $paddingInlineStart, DEVICE_TYPES.MOBILE), ({
  theme,
  $paddingInlineEnd
}) => getPadding(theme, $paddingInlineEnd, DEVICE_TYPES.MOBILE))));

export { BoxStyled as B };
//# sourceMappingURL=Box.styles-EHRquw_m.js.map
